import { useAuth } from "app/authHooks";
import useMessage from "./useMessage";
import { Permission, hasPermission } from "core/utils/roles";

export function usePermissionAction(permission: Permission) {
  const { attributes } = useAuth();
  const message = useMessage();
  const allowed = hasPermission(permission);
  const actionWithoutPermission = () => message.error("No Permission");

  return function <T extends (...args: any[]) => any>(
    allowedAction: T,
    notAllowedAction: T = actionWithoutPermission as T
  ): T {
    return allowed ? allowedAction : notAllowedAction;
  };
}
